import React from 'react';
import { convocatorias } from '../../json/convocatorias';
import './convocatorias.css';

const ConvocatoriasNew = () => {
  return (
    <div className="pagina-convocatorias">
    
      <header className="encabezado-pagina">
        <h1 className="titulo-pagina">Catálogo de convocatorias</h1>
        <p className="subtitulo-pagina">Descubre las oportunidades para artistas y creadores en Hidalgo</p>
      </header>
      <main className="contenedor-convocatorias">
{convocatorias.map((convocatoria, index) => (
  <section key={index} className="seccion-convocatoria">
    <div className='contenedor-titulo-seccion'>
      <h2 className='titulo-seccion'>{convocatoria.titulo_principal}</h2> 
      <div className='linea-decorativa'></div>
    </div>
    
    <div className='tarjeta-convocatoria'>
      <a href={convocatoria.url} target="_blank" rel="noopener noreferrer" className="enlace-convocatoria">
        <div 
          className="imagen-convocatoria" 
          style={{ backgroundImage: `url('${convocatoria.imagen}')` }}
        >

          <div className='fecha-superior'>
            <span className='icono-calendario'></span> {convocatoria.fecha}
          </div>
          
          <div className='overlay'></div>
          
          <div className='contenido-texto'>
            <h3 className='titulo-convocatoria'>{convocatoria.titulo}</h3>
            <div className={`badge-urgente ${convocatoria.estado === "CONVOCATORIA CERRADA" ? "cerrada" : "abierta"}`}>
              {convocatoria.estado}
            </div>
          </div>
        </div>
      </a>
    </div>
  </section>
))}
      </main>
    </div>
  );
};

export default ConvocatoriasNew;